"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const inertia_1 = require("@inertiajs/inertia");
const inertia_react_1 = require("@inertiajs/inertia-react");
const react_1 = __importStar(require("react"));
const ziggy_js_1 = __importDefault(require("ziggy-js"));
const MultipleInputs_1 = __importDefault(require("../../../components/MultipleInputs"));
const Layout_1 = __importDefault(require("../Layout/Layout"));
const DeleteButton_1 = __importDefault(require("../Shared/DeleteButton"));
const FlashMessages_1 = __importDefault(require("../Shared/FlashMessages"));
const LoadingButton_1 = __importDefault(require("../Shared/LoadingButton"));
const SelectInput_1 = __importDefault(require("../Shared/SelectInput"));
const uuid_1 = require("uuid");
const TextInput_1 = __importDefault(require("../Shared/TextInput"));
const Edit = () => {
    const { homepageDataModel } = (0, inertia_react_1.usePage)().props;
    const [inputs, setInputs] = (0, react_1.useState)([{ id: (0, uuid_1.v4)(), label: "", value: "" }]);
    const categorys = [
        { type: "HEALTH", name: "Santé et nutrition" },
        { type: "EDUCAT", name: "Education" },
        { type: "CHILDP", name: "Protection de l'enfants" },
        { type: "ENVIRO", name: "Eau, assainissement et hygiène" },
        { type: "SOCIAL", name: "Politique sociale" },
        { type: "CIVILR", name: "Participation et droits civils" },
    ];
    const chartTypes = [
        { type: "bar" },
        { type: "line" },
        { type: "pie" },
        { type: "doughnut" },
        { type: "polararea" },
        { type: "radar" },
    ];
    const { data, setData, errors, put, processing } = (0, inertia_react_1.useForm)({
        year: homepageDataModel.year,
        title: homepageDataModel.title,
        subtitle: homepageDataModel.subtitle,
        category: homepageDataModel.category,
        charttype: homepageDataModel.charttype,
        dataset: inputs
    });
    function handleSubmit(e) {
        e.preventDefault();
        put((0, ziggy_js_1.default)("homepagedata.update", homepageDataModel.id));
    }
    function destroy() {
        if (confirm("Are you sure you want to delete this contact?")) {
            inertia_1.Inertia.delete((0, ziggy_js_1.default)("homepagedata.destroy", homepageDataModel.id));
        }
    }
    (0, react_1.useEffect)(() => {
        const inputData = JSON.parse(homepageDataModel.json_data);
        inputData.forEach((input) => {
            if (input.label == null)
                input.label = "";
            if (input.value == null)
                input.value = "";
        });
        setInputs(inputData);
    }, []);
    (0, react_1.useEffect)(() => {
        setData("dataset", inputs);
    }, [inputs]);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(FlashMessages_1.default, null),
        react_1.default.createElement("h1", { className: "mb-8 text-3xl font-bold" },
            react_1.default.createElement(inertia_react_1.InertiaLink, { href: (0, ziggy_js_1.default)("homepagedata.index"), className: "text-[#004e81]  hover:text-[#113953]" }, "Homepage Data"),
            react_1.default.createElement("span", { className: "font-medium text-[#004e81] " }, " /"),
            " \u00C9diter"),
        react_1.default.createElement("div", { className: "max-w-3xl overflow-hidden bg-white rounded shadow" },
            react_1.default.createElement("form", { onSubmit: handleSubmit },
                react_1.default.createElement("div", { className: "flex flex-wrap p-8 -mb-8 -mr-6" },
                    react_1.default.createElement(TextInput_1.default, { className: "w-full pb-8 pr-6 lg:w-1/2", label: "Titre", name: "title", errors: errors.title, value: data.title, onChange: (e) => setData("title", e.target.value) }),
                    react_1.default.createElement(TextInput_1.default, { className: "w-full pb-8 pr-6 lg:w-1/2", label: "Sous-titre", name: "subtitle", errors: errors.subtitle, value: data.subtitle, onChange: (e) => setData("subtitle", e.target.value) }),
                    react_1.default.createElement(TextInput_1.default, { className: "w-full pb-8 pr-6 lg:w-1/2", label: "Ann\u00E9e", name: "year", errors: errors.year, value: data.year, onChange: (e) => {
                            const val = e.target.value;
                            if (e.target.validity.valid) {
                                setData("year", e.target.value);
                            }
                            else if (val === "") {
                                setData("year", "");
                            }
                        }, number: true }),
                    react_1.default.createElement(SelectInput_1.default, { className: "w-full pb-8 pr-6 lg:w-1/2", label: "Cat\u00E9gorie", name: "category", errors: errors.category, value: data.category, onChange: (e) => setData("category", e.target.value) }, categorys.map(({ type, name }) => (react_1.default.createElement("option", { key: type, value: type }, name)))),
                    react_1.default.createElement(SelectInput_1.default, { className: "w-full pb-8 pr-6", label: "Charttype", name: "charttype", errors: errors.charttype, value: data.charttype, onChange: (e) => setData("charttype", e.target.value) }, chartTypes.map(({ type }) => (react_1.default.createElement("option", { key: type, value: type }, type)))),
                    react_1.default.createElement("label", { className: " mb-6", htmlFor: "" }, "Data:"),
                    react_1.default.createElement(MultipleInputs_1.default, { inputs: inputs, setInputs: setInputs })),
                react_1.default.createElement("div", { className: "flex items-center px-8 py-4 bg-gray-100 border-t border-gray-200" },
                    react_1.default.createElement(DeleteButton_1.default, { onDelete: destroy }, "Supprimer Homepage Data"),
                    react_1.default.createElement(LoadingButton_1.default, { loading: processing, type: "submit", className: "ml-auto btn-indigo" }, "\u00C9diter Homepage Data"))))));
};
Edit.layout = (page) => react_1.default.createElement(Layout_1.default, { title: "Edit Homepage Data", children: page });
exports.default = Edit;
